import { Check, Heart } from "lucide-react";
import { DECORACOES } from "@/data/acomodacoes";
import { brl } from "@/lib/pricing";

export const Toggle = ({ value, onChange, testid, options = [["sim", "Sim"], ["nao", "Não"]] }) => (
  <div className="inline-flex rounded-full border border-[#c9c0aa] p-1">
    {options.map(([v, l]) => (
      <button
        key={v}
        type="button"
        data-testid={`${testid}-${v}`}
        onClick={() => onChange(v)}
        className={`rounded-full px-6 py-2 text-sm transition-[background-color,color] duration-300 ${
          value === v ? "bg-[#1a382b] text-[#f3efe4]" : "text-[#1a382b] hover:bg-[#e6dfcf]"
        }`}
      >
        {l}
      </button>
    ))}
  </div>
);

const Opcao = ({ d, on, onClick }) => (
  <button
    type="button"
    data-testid={`decoration-option-${d.id}`}
    onClick={onClick}
    className={`group relative flex flex-col overflow-hidden bg-white text-left transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl ${
      on ? "ring-2 ring-[#8b1e24]" : "ring-1 ring-[#d9d2c1]"
    }`}
  >
    <div className="relative aspect-[3/2] overflow-hidden">
      <img src={d.imagem} alt={`Decoração ${d.nome}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <span className="absolute left-0 top-3 bg-[#6e1419] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-[#f6e7d2]">Opção {d.opcao}</span>
      {on && (
        <span className="absolute right-2 top-2 grid h-8 w-8 place-items-center rounded-full bg-[#8b1e24] text-white">
          <Check className="h-4 w-4" />
        </span>
      )}
    </div>
    <div className="flex flex-1 flex-col p-4">
      <div className="flex items-baseline justify-between gap-2">
        <p className="text-xl font-bold text-[#6e1419]">{d.nome}</p>
        <p data-testid={`decoration-price-${d.id}`} className="text-lg font-bold text-[#1a382b]">{brl(d.preco)}</p>
      </div>
      <p className="mt-1 text-sm italic text-[#5f6e62]">{d.descricao}</p>
      <ul className="mt-3 space-y-1.5">
        {d.itens.map((it) => (
          <li key={it} className="flex gap-2 text-[13px] leading-snug text-[#263228]">
            <Heart className="mt-0.5 h-3.5 w-3.5 shrink-0 fill-[#b3262e] text-[#b3262e]" />
            {it}
          </li>
        ))}
      </ul>
      <p className="mt-auto pt-4 text-[11px] font-bold uppercase tracking-[0.12em] text-[#a85d38]">{d.ideal}</p>
    </div>
  </button>
);

export const Decoracao = ({ value, onChange, error }) => (
  <div data-testid="decoration-options" className="mt-5 grid gap-4 md:grid-cols-3">
    {DECORACOES.map((d) => (
      <Opcao key={d.id} d={d} on={value === d.id} onClick={() => onChange(d.id)} />
    ))}
    {error && <p className="text-sm text-red-700 md:col-span-3">{error}</p>}
  </div>
);
